export default "__VITE_ASSET__DyiUGgWW__"